import { useCallback } from 'react'
import { styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { Hall } from '@weblite/ts-action/hall'
import { Room } from '@weblite/ts-action/room'
import { t } from '$i18n'
import { PrimaryButton } from '$common/buttons'
import { BottomDrawer } from '$common/bottom-drawer'
import { HallAvatar } from '$common/avatar/hall-avatar'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { joinHallViaLink } from '$logic/subscription/client.service'

interface Props {
  isOpen?: boolean
  hall: Hall
  room: Room
  link: string
}
export function RequestToJoinHallDialog({ isOpen, hall, room, link }: Props) {
  const handleClose = useCallback(async () => {
    await closeCurrentModal()
  }, [])

  const handleConfirm = useCallback(async () => {
    analite('CHAT_REQUEST_TO_JOIN', {
      source: 'INVITE_LINK',
      name: hall?.identifier,
    })
    await joinHallViaLink(link, true, closeCurrentModal)
  }, [hall?.identifier, link])

  return (
    <BottomDrawer isOpen={Boolean(isOpen)} onClose={handleClose}>
      <Root>
        <HallAvatar roomId={room.id} size={AvatarSize.XL} sx={{ mb: '16px' }} />
        <Typography variant="subtitle3" mb="4px" color="neutral900">
          {hall?.name}
        </Typography>
        <Typography variant="caption1" mb="24px" color="neutral500">
          {t('requestToJoinHallDialog.subtitle')(room.type)}
        </Typography>
        <PrimaryButton
          text={
            <Typography variant="subtitle1" color="inherit">
              {t('requestToJoinHallDialog.confirmText')}
            </Typography>
          }
          onClick={handleConfirm}
          sx={{ mb: '16px' }}
          fullWidth
        />
        <Typography variant="caption1" color="neutral600" textAlign="center">
          {t('requestToJoinHallDialog.description')(room.type)}
        </Typography>
      </Root>
    </BottomDrawer>
  )
}

const Root = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 24px 20px 20px;
`
